import apiService from '../infrastructure/api.service.js';
import authStorageService from '../auth/auth-storage.service.js';

export const paymentService = {
    getAllTransactions,
    logout,
    authorizeTransaction,
    getTransactionByReference,
    getTransactionByReferenceAndServiceProviderAndType,
    authorizeTransactionReversal,
    initiateTransaction,
    getAllReversals,
    getTransactionReceipt
};

export const state = { status: false };

async function getAllTransactions() {
    return apiService.get('/transactions');
}

async function getTransactionByReference(reference) {
    return apiService.get(`/transactions/${reference}`);
}

async function getTransactionByReferenceAndServiceProviderAndType(reference, serviceProviderID, serviceType) {
    return apiService.get(`/getTransaction/${serviceType}/${serviceProviderID}/${reference}`);
}

function logout() {
    // Logout logic can be implemented here if needed
}

async function initiateTransaction(transaction) {
    return apiService.post('/transaction/save', transaction);
}

async function authorizeTransaction(transaction) {
    return apiService.post('/teller/updateActivity', transaction);
}

async function authorizeTransactionReversal(transaction) {
    return apiService.post('/supervisor/updateActivity', transaction);
}

async function getAllReversals() {
    return apiService.get('/transactions/reversals');
}

async function getTransactionReceipt(referenceNumber) {
    const requestBody = {
        operation: "getReceipt",
        accessToken: authStorageService.getAccessToken(),
        requestBody: {
            reference_number: referenceNumber
        }
    };

    return apiService.post('/iremitify/payout/transaction/receipt', requestBody);
}